<template>
  <div>
    <div v-if="!trace_loading">
    <div v-for="(package_detail_info, i) in package_detail_info_list" :key="i" class="order-trace-wrap">
      <div class="order-trace">
        <div class="logistic_detail">
         
          <Timeline>
              <TimelineItem v-for="(item, index) in package_detail_info.logistic_detail_info_list" :key="index">
                <div style="position: relative;">              
                  <span style="display: inline-block;position: absolute;left: -150px;">{{formatTime(item.event_time)}}</span>
                  <p class="time">{{item.title}}</p>
                  <p class="content"><pre style="max-width: 600px;" 
                        v-html="item.description"
                      ></pre></p>
                </div>
              </TimelineItem>
          </Timeline>
        </div>
        <Divider />
        <div style="font-weight: bold;">
          跟踪单号: {{package_detail_info.tracking_number}}
        </div>
      </div>
    </div>
    <Empty v-if="package_detail_info_list.length == 0" :load="1"></Empty>
    </div>

    <div v-if="trace_loading" style="height: 600px;">
      <div style="position: absolute;top: 20%;left: 50%;" class="trace-loading">
        <Col class="demo-spin-col" span="8">
            <Spin fix>
              <img style="max-width: 100px;"  :src="require('@/static/img/trace.gif')">
            </Spin>
        </Col>
      </div>
    </div>
  </div>
</template>
<script>
import conf from "../../conf";
import RequestUtils from "@/utils/RequestUtils";
import Empty from "../empty.vue";
const { formatDateTime } = require("@/utils/ChatUtils");

export default {
  name: "faces",
  components: {
    Empty
  },
  data() {
    return {
      package_detail_info_list: [],
      trace_loading: false
    };
  },
  props: ["orderId"],
  methods: {
    formatTime (event_time) {
      return formatDateTime(new Date(event_time)).substr();
    },
    getTrace () {
      let param = new FormData();
      param.set("store_id", this.$store.state.lazada.currentStore.id);
      param.set("order_id", this.orderId);
      this.trace_loading = true;
      RequestUtils.request(conf.getTrace(), param).then(json => {
        this.trace_loading = false;
        if (json.module && json.module[0]['package_detail_info_list']) {
          let package_detail_info_list = json.module[0]['package_detail_info_list'];
          for (let i=0; i<package_detail_info_list.length; i++)
          {
            let logistic_detail_info_list = new Array();
            for (let j=0; j<package_detail_info_list[i].logistic_detail_info_list.length; j++) {
              if (package_detail_info_list[i].logistic_detail_info_list[j].title) {
                logistic_detail_info_list.push(package_detail_info_list[i].logistic_detail_info_list[j]);
              }
            }
            package_detail_info_list[i].logistic_detail_info_list = logistic_detail_info_list.reverse();
          }
          this.package_detail_info_list = package_detail_info_list;
        } else {
          this.package_detail_info_list = [];
        }
        
      })
    }
  },
  watch: {
    orderId () {
      this.getTrace();
    }
  }
};
</script>

<style scoped lang="scss">

.order-trace {
  
  height: 600px;
  overflow: scroll;

  .logistic_detail {
    display: flex;
    padding-left: 150px;

    .date-line {
      list-style: none;
      margin-right: 1rem;

      .date-item {
        height: 100px;
        width: 111px;
      }
    }
  }
}
</style>
